module.exports = __webpack_public_path__ + "static/media/test9_1.5863e1be.png";